class MobileMenu {
  constructor() {
    this.menuToggle = document.querySelector('.header__mobile-toggle');
    this.mobileMenu = document.getElementById('mobile-menu');
    this.body = document.body;
    
    if (this.menuToggle && this.mobileMenu) {
      this.setupToggle();
      this.setupAccordions();
    }
  }

  setupToggle() {
    this.menuToggle.addEventListener('click', () => {
      if (this.body.classList.contains('mobile-menu-open')) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
    
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeMenu();
    });
  }

  setupAccordions() {
    // Handle main menu toggles
    const mainToggles = this.mobileMenu.querySelectorAll('.mobile-menu__link--has-menu');
    mainToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const menuItem = toggle.closest('.mobile-menu__item');
        const submenu = menuItem.querySelector('.mobile-menu__submenu');
        
        if (!submenu) return;
        
        // Close other main menus
        mainToggles.forEach(otherToggle => {
          if (otherToggle !== toggle) {
            const otherItem = otherToggle.closest('.mobile-menu__item');
            otherItem.classList.remove('mobile-menu__item--expanded');
          }
        });
        
        // Toggle this menu
        menuItem.classList.toggle('mobile-menu__item--expanded');
      });
    });
    
    // Handle submenu toggles
    const subToggles = this.mobileMenu.querySelectorAll('.mobile-menu__link--has-submenu');
    subToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const menuItem = toggle.closest('.mobile-menu__item');
        const submenu = menuItem.querySelector('.mobile-menu__submenu');
        
        if (!submenu) return;
        
        const parentList = menuItem.parentNode;
        
        // Close sibling submenus
        const siblingToggles = parentList.querySelectorAll(':scope > .mobile-menu__item > .mobile-menu__link--has-submenu');
        siblingToggles.forEach(siblingToggle => {
          if (siblingToggle !== toggle) {
            const siblingItem = siblingToggle.closest('.mobile-menu__item');
            siblingItem.classList.remove('mobile-menu__item--expanded');
          }
        });
        
        // Toggle this submenu
        menuItem.classList.toggle('mobile-menu__item--expanded');
      });
    });
  }

  openMenu() {
    this.body.classList.add('mobile-menu-open');
    this.menuToggle.setAttribute('aria-expanded', 'true');
    this.body.style.overflow = 'hidden';
  }

  closeMenu() {
    this.body.classList.remove('mobile-menu-open');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    this.body.style.overflow = '';
    
    // Close all accordions
    const expandedItems = this.mobileMenu.querySelectorAll('.mobile-menu__item--expanded');
    expandedItems.forEach(item => item.classList.remove('mobile-menu__item--expanded'));
  }
}

export default MobileMenu;
